import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyTitle: {
    id: 'comp.ConversionsTab.emptyTitle',
    defaultMessage: 'No formats yet',
  },
  emptyExplainer: {
    id: 'comp.ConversionsTab.emptyExplainer',
    defaultMessage:
      'Formats (conversions) are ready-to-use versions of this file — resized images, web-friendly videos, subtitles. They are created automatically when processing runs, or added by apps like Photoshop.',
  },
  emptyConfigureLink: {
    id: 'comp.ConversionsTab.emptyConfigureLink',
    defaultMessage: 'Configure automatic formats in Settings',
  },
  colName: {
    id: 'comp.ConversionsTab.colName',
    defaultMessage: 'Name',
  },
  colType: {
    id: 'comp.ConversionsTab.colType',
    defaultMessage: 'Type',
  },
  colPublic: {
    id: 'comp.ConversionsTab.colPublic',
    defaultMessage: 'Public',
  },
  colDimensions: {
    id: 'comp.ConversionsTab.colDimensions',
    defaultMessage: 'Dimensions',
  },
  colDuration: {
    id: 'comp.ConversionsTab.colDuration',
    defaultMessage: 'Duration',
  },
  colDpi: {
    id: 'comp.ConversionsTab.colDpi',
    defaultMessage: 'DPI',
  },
  publicColumnHint: {
    id: 'comp.ConversionsTab.publicColumnHint',
    defaultMessage:
      'Public files are served from the CDN — anyone with the link can view them. Private files need a temporary signed link.',
  },
  publicBadge: {
    id: 'comp.ConversionsTab.publicBadge',
    defaultMessage: 'Public',
  },
  privateBadge: {
    id: 'comp.ConversionsTab.privateBadge',
    defaultMessage: 'Private',
  },
  makePublicTitle: {
    id: 'comp.ConversionsTab.makePublicTitle',
    defaultMessage: 'Make this file public?',
  },
  makePublicMessage: {
    id: 'comp.ConversionsTab.makePublicMessage',
    defaultMessage:
      'Anyone with the link will be able to view it, and it may be cached by the CDN. You can make it private again at any time.',
  },
  toggleFailed: {
    id: 'comp.ConversionsTab.toggleFailed',
    defaultMessage: 'Could not change visibility. Please try again.',
  },
  nowPublic: {
    id: 'comp.ConversionsTab.nowPublic',
    defaultMessage: 'This format is now public.',
  },
  nowPrivate: {
    id: 'comp.ConversionsTab.nowPrivate',
    defaultMessage: 'This format is now private.',
  },
  previewTip: {
    id: 'comp.ConversionsTab.previewTip',
    defaultMessage: 'Preview',
  },
  closePreviewTip: {
    id: 'comp.ConversionsTab.closePreviewTip',
    defaultMessage: 'Close preview',
  },
  previewLoading: {
    id: 'comp.ConversionsTab.previewLoading',
    defaultMessage: 'Loading preview…',
  },
  previewFailed: {
    id: 'comp.ConversionsTab.previewFailed',
    defaultMessage: 'Could not load the preview. Please try again.',
  },
  editTip: {
    id: 'comp.ConversionsTab.editTip',
    defaultMessage: 'Edit',
  },
  downloadTip: {
    id: 'comp.ConversionsTab.downloadTip',
    defaultMessage: 'Download',
  },
  linksTip: {
    id: 'comp.ConversionsTab.linksTip',
    defaultMessage: 'Get links for this format',
  },
  copyPermanentTip: {
    id: 'comp.ConversionsTab.copyPermanentTip',
    defaultMessage: 'Copy permanent CDN link',
  },
  copyTemporaryTip: {
    id: 'comp.ConversionsTab.copyTemporaryTip',
    defaultMessage: 'Copy temporary link (expires in 24 hours)',
  },
  permanentLinkCopied: {
    id: 'comp.ConversionsTab.permanentLinkCopied',
    defaultMessage: 'Permanent CDN link copied',
  },
  temporaryLinkCopied: {
    id: 'comp.ConversionsTab.temporaryLinkCopied',
    defaultMessage: 'Temporary link copied — expires in 24 hours',
  },
  linkFailed: {
    id: 'comp.ConversionsTab.linkFailed',
    defaultMessage: 'Error getting the link. Please try again.',
  },
  downloadFailed: {
    id: 'comp.ConversionsTab.downloadFailed',
    defaultMessage: "We're not able to provide a downloadable file right now, please try again later.",
  },
  embedTip: {
    id: 'comp.ConversionsTab.embedTip',
    defaultMessage: 'Embed on a web page',
  },
  embedNeedsPublicTip: {
    id: 'comp.ConversionsTab.embedNeedsPublicTip',
    defaultMessage: 'Make this format public to embed it',
  },
  embedTitle: {
    id: 'comp.ConversionsTab.embedTitle',
    defaultMessage: 'Embed video',
  },
  embedHelp: {
    id: 'comp.ConversionsTab.embedHelp',
    defaultMessage: 'Paste this snippet into your web page or CMS. The video plays from the FileSpin CDN.',
  },
  embedCopy: {
    id: 'comp.ConversionsTab.embedCopy',
    defaultMessage: 'Copy embed code',
  },
  embedCopied: {
    id: 'comp.ConversionsTab.embedCopied',
    defaultMessage: 'Embed code copied',
  },
  errorBadge: {
    id: 'comp.ConversionsTab.errorBadge',
    defaultMessage: 'Error',
  },
  // Renditions refused at transcode time because the account had too few
  // credits (conf/22). The original is stored; nothing was charged.
  creditsSkippedTitle: {
    id: 'comp.ConversionsTab.creditsSkippedTitle',
    defaultMessage:
      '{count, plural, one {# format was} other {# formats were}} not processed: not enough credits.',
  },
  creditsSkippedBody: {
    id: 'comp.ConversionsTab.creditsSkippedBody',
    defaultMessage: 'Your original is stored and nothing was charged. Process them once credits are added.',
  },
  processOne: {
    id: 'comp.ConversionsTab.processOne',
    defaultMessage: 'Process',
  },
  processAll: {
    id: 'comp.ConversionsTab.processAll',
    defaultMessage: 'Process all',
  },
  processBusy: {
    id: 'comp.ConversionsTab.processBusy',
    defaultMessage: 'Starting…',
  },
  processQueuedShort: {
    id: 'comp.ConversionsTab.processQueuedShort',
    defaultMessage: 'Processing…',
  },
  processQueued: {
    id: 'comp.ConversionsTab.processQueued',
    defaultMessage: 'Processing started. The formats appear here when they are ready.',
  },
  processStillShort: {
    id: 'comp.ConversionsTab.processStillShort',
    defaultMessage: 'Still not enough credits: this needs {required} and the account has {balance}.',
  },
  processFailed: {
    id: 'comp.ConversionsTab.processFailed',
    defaultMessage: 'Could not start processing. Please try again.',
  },
  addCredits: {
    id: 'comp.ConversionsTab.addCredits',
    defaultMessage: 'Add credits',
  },
});
